import * as yup from "yup";
import { statesList } from "core/utils/statesList";
import { getText } from "core/utils/getContentText";
import {
  formatNumberChange,
  formatNumberKeyDown,
} from "components/TextFields/MobileUtils";
import { InputAdornment } from "@mui/material";
import { isBuilderAdmin, isHomeOwner } from "core/utils/roleUtils";
import { phoneRegExp } from "constants/appConstants";
import {
  fieldsValidation,
  formatNumber,
  getRawNumberValue,
} from "core/utils/localizationUtils";

const getTextContent = (key) => getText(`projects.addProperty.${key}`);

const addPropertyValidationSchema = yup.object({
  address: yup.string("Enter address").required("address is required"),
  city: yup.string("Enter city").required("city is required"),
  state: yup.string("Enter state").required("state is required"),
  zip: yup.string("Enter zipcode").required("ZipCode is required"),
  propertyLocation: yup
    .string("Enter Property Location")
    .required("Property Location is required"),
  // homeOwnerName: yup
  // 	.string("Enter Homeowner Name")
  // 	.required("Homeowner Name is required"),
  homeOwnerMobile: yup
    .string("Enter your Mobile")
    .matches(phoneRegExp, "Phone number is not valid"),
  preliminarySalesPrice: fieldsValidation
    .number("Sale Price")
    .required("Preliminary Sales Price is required"),
  plotArea: fieldsValidation
    .number("Plot Area")
    .required("Enter Plot Area in Sq.Ft"),
});

export const addPropertyForm = {
  steps: Array.from({ length: 1 }, (_, index) =>
    getText(`profile.contractor.step${index + 1}`)
  ),
  formFields: {
    step0: [
      {
        key: "propertyName",
        placeholder: "Property Name",
        label: getTextContent("propertyName"),
        type: "text",
        width: "100%",
        shouldHide: ({ projEqualProp }) => projEqualProp,
      },
      {
        key: "address",
        placeholder: "Property Address",
        label: getTextContent("propertyAddress"),
        type: "textArea",
        required: true,
        width: "100%",
      },
      {
        key: "city",
        placeholder: "City",
        label: getTextContent("city"),
        type: "text",
        required: true,
        width: "33%",
      },
      {
        key: "state",
        placeholder: "state",
        label: getTextContent("state"),
        type: "select",
        select: true,
        options: statesList,
        required: true,
        width: "33%",
      },
      {
        key: "zip",
        placeholder: "Zip",
        label: getTextContent("zip"),
        type: "text",
        required: true,
        width: "33%",
      },
      // {
      // 	key: "homeOwnerName",
      // 	placeholder: "Homeowner Name",
      // 	label: getTextContent("homeownerName"),
      // 	type: "text",
      // 	required: true,
      // 	width: "50%",
      // },
      {
        key: "userId",
        placeholder: "Select Homeowner",
        label: getTextContent("homeownerName"),
        type: "select",
        // required: true,
        width: "50%",
        select: true,
        options: [],
        dynamicField: true,
        renderCondition: (_, profile) => {
          return !isHomeOwner(profile);
        },
      },
      {
        key: "companyId",
        placeholder: "Select Builder",
        label: "Select Builder",
        type: "select",
        // required: true,
        width: "50%",
        select: true,
        options: [],
        dynamicField: true,
        renderCondition: (_, profile) => {
          return !isBuilderAdmin(profile);
        },
      },
      {
        key: "homeOwnerMobile",
        placeholder: "(xxx) xxx-xxxx",
        label: getTextContent("homeownerMobile"),
        type: "mobile",
        // required: true,
        width: "50%",
        // renderCondition: (_, profile) => isHomeOwner(profile),
        extraInputProps: (formik) => ({
          onChange: (e) => {
            const onValidation = (validatedValue) => {
              formik.setFieldValue("homeOwnerMobile", validatedValue);
            };
            formatNumberChange(e, onValidation);
          },
          onKeyDown: (e) => {
            const onValidation = (validatedValue) => {
              formik.setFieldValue("homeOwnerMobile", validatedValue);
            };
            formatNumberKeyDown(e, onValidation);
          },
          InputProps: {
            startAdornment: (
              <InputAdornment position="start">
                <span class="flag-icon flag-icon-us"></span> +1
              </InputAdornment>
            ),
          },
        }),
      },
      {
        key: "preliminarySalesPrice",
        placeholder: "Enter Sale Price",
        label: "Preliminary Sales Price",
        required: true,
        width: "50%",
        customValue: formatNumber,
        extraInputProps: (formik) => ({
          InputProps: {
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          },
          onChange: (e) => {
            const validValue = getRawNumberValue(e.target.value);
            formik.setFieldValue("preliminarySalesPrice", validValue);
          },
        }),
      },
      {
        key: "plotArea",
        placeholder: "Enter Plot Area in Sq.Ft",
        label: "Plot Area (Sq.Ft.)",
        width: "50%",
        required: true,
        customValue: formatNumber,
        extraInputProps: (formik) => ({
          onChange: (e) => {
            const validValue = getRawNumberValue(e.target.value);
            formik.setFieldValue("plotArea", validValue);
          },
        }),
      },
      {
        key: "propertyNotes",
        placeholder: "Enter notes/details related to property here",
        label: "Property Notes",
        type: "textArea",
        width: "100%",
        shouldHide: ({ projEqualProp }) => projEqualProp,
        extraInputProps: {
          multiline: true,
          className: "registration-formField property-details-textarea",
        },
      },
    ],
  },
  validationSchema: addPropertyValidationSchema,
  defaultState: (defaultState) => {
    if (defaultState) {
      return defaultState;
    }
    const initialState = Object.fromEntries(
      Object.keys(addPropertyValidationSchema.fields).map((key) => {
        return [key, ""];
      })
    );
    return {
      ...initialState,
    };
  },
};
